import { render, staticRenderFns } from "./RecruitmentReport.vue?vue&type=template&id=6defcc46"
import script from "./RecruitmentReport.vue?vue&type=script&lang=js"
export * from "./RecruitmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports